module.exports = __webpack_public_path__ + "static/img/membership-bg.09f6367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-welfare/membership-bg.png
// module id = mLSR
// module chunks = 215